// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Routing
import { LoginRoutingModule } from './login-routing.module';
// Modules
import { MedsurfViewerCommonModule } from '../common/medsurf-viewer-common.module';
// Components
import { LoginComponent } from './login.component';

/**
 * Login Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Translate
    TranslateModule.forChild(),
    // Routing
    LoginRoutingModule,
    // Modules
    MedsurfViewerCommonModule,
  ],
  declarations: [
    // Components
    LoginComponent,
  ]
})
export class LoginModule {
}
